import React from 'react';
import { MultiCombobox } from '~/components/uie-fix/MultiCombobox';
import { useFilterField } from '../../hooks/useFilterField';
import { useStaticProps } from '../../context';

export const CampusesFilter = () => {
  const campusFilter = useFilterField('campusId', 'PrimaryFilter');
  const { referenceData } = useStaticProps();

  const campuses = React.useMemo(
    () =>
      Object.entries(referenceData.campuses)
        .map(([k, v]) => ({ label: v.name, value: k }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [referenceData.campuses]
  );

  return (
    <MultiCombobox
      value={campusFilter.value}
      aria-label="Campus"
      placeholder="Campus"
      onChange={(selectedItems) => campusFilter.setValue(selectedItems.filter((s) => !!s.trim()))}
      placeholderVariant="indicator"
    >
      {Object.entries(campuses).map(([id, { label, value }]) => (
        <MultiCombobox.Option label={label} value={value} key={id} />
      ))}
    </MultiCombobox>
  );
};
